import { c as _c } from "react/compiler-runtime";
import type { ApiProfileProxy } from "@/generated/models/ApiProfileProxy";
export default function HeaderUserProxyDropdownItem(t0) {
  const $ = _c(24);
  const {
    profileProxy,
    activeProfileProxy,
    onActivateProfileProxy
  } = t0;
  const isActive = profileProxy.id === activeProfileProxy?.id;
  const t1 = `${!isActive ? "tw-bg-transparent hover:tw-bg-iron-700" : "tw-bg-iron-700"} tw-group tw-py-2.5 tw-w-full tw-h-full tw-border-none tw-text-left tw-flex tw-items-center tw-gap-x-3 tw-text-white tw-rounded-lg tw-relative tw-cursor-pointer tw-select-none tw-px-3 focus:tw-outline-none focus:tw-ring-1 focus:tw-ring-primary-400 tw-transition tw-duration-300 tw-ease-out`;
  let t2;
  if ($[0] !== isActive || $[1] !== onActivateProfileProxy || $[2] !== profileProxy) {
    t2 = () => onActivateProfileProxy(isActive ? null : profileProxy);
    $[0] = isActive;
    $[1] = onActivateProfileProxy;
    $[2] = profileProxy;
    $[3] = t2;
  } else {
    t2 = $[3];
  }
  let t3;
  if ($[4] !== isActive || $[5] !== profileProxy.created_by.pfp) {
    t3 = profileProxy.created_by.pfp ? <img src={profileProxy.created_by.pfp} alt="Profile Picture" className="tw-flex-shrink-0 tw-h-6 tw-w-6 tw-flex-none tw-rounded-lg tw-bg-iron-800" /> : <div className={`${isActive ? "tw-bg-iron-600" : "tw-bg-iron-700 group-hover:tw-bg-iron-600"} tw-flex-shrink-0 tw-h-6 tw-w-6 tw-flex-none tw-rounded-lg tw-transition tw-duration-300 tw-ease-out`} />;
    $[4] = isActive;
    $[5] = profileProxy.created_by.pfp;
    $[6] = t3;
  } else {
    t3 = $[6];
  }
  let t4;
  if ($[7] !== profileProxy.created_by.handle) {
    t4 = <div className="tw-truncate tw-text-md tw-font-medium tw-text-white">{profileProxy.created_by.handle}</div>;
    $[7] = profileProxy.created_by.handle;
    $[8] = t4;
  } else {
    t4 = $[8];
  }
  let t5;
  if ($[9] === Symbol.for("react.memo_cache_sentinel")) {
    t5 = <span className="tw-pl-2 tw-pr-0.5 tw-italic tw-text-sm tw-text-iron-400 tw-font-normal">Proxy</span>;
    $[9] = t5;
  } else {
    t5 = $[9];
  }
  let t6;
  if ($[10] !== t4) {
    t6 = <div className="tw-truncate tw-inline-flex tw-items-center tw-justify-between">{t4}{t5}</div>;
    $[10] = t4;
    $[11] = t6;
  } else {
    t6 = $[11];
  }
  let t7;
  if ($[12] !== isActive) {
    t7 = isActive && <svg className="tw-flex-shrink-0 tw-h-5 tw-w-5 tw-ml-2 tw-text-primary-400 tw-transition tw-duration-300 tw-ease-out" viewBox="0 0 24 24" fill="none" aria-hidden="true" xmlns="http://www.w3.org/2000/svg"><path d="M20 6L9 17L4 12" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" /></svg>;
    $[12] = isActive;
    $[13] = t7;
  } else {
    t7 = $[13];
  }
  let t8;
  if ($[14] !== t7) {
    t8 = <div>{t7}</div>;
    $[14] = t7;
    $[15] = t8;
  } else {
    t8 = $[15];
  }
  let t9;
  if ($[16] !== t6 || $[17] !== t8) {
    t9 = <div className="tw-flex tw-justify-between tw-items-center tw-w-full">{t6}{t8}</div>;
    $[16] = t6;
    $[17] = t8;
    $[18] = t9;
  } else {
    t9 = $[18];
  }
  let t10;
  if ($[19] !== t1 || $[20] !== t2 || $[21] !== t3 || $[22] !== t9) {
    t10 = <div className="tw-h-full"><button type="button" className={t1} onClick={t2}>{t3}{t9}</button></div>;
    $[19] = t1;
    $[20] = t2;
    $[21] = t3;
    $[22] = t9;
    $[23] = t10;
  } else {
    t10 = $[23];
  }
  return t10;
}